"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTestCardFileDto = instanceOfTestCardFileDto;
exports.TestCardFileDtoFromJSON = TestCardFileDtoFromJSON;
exports.TestCardFileDtoFromJSONTyped = TestCardFileDtoFromJSONTyped;
exports.TestCardFileDtoToJSON = TestCardFileDtoToJSON;
exports.TestCardFileDtoToJSONTyped = TestCardFileDtoToJSONTyped;
/**
 * Check if a given object implements the TestCardFileDto interface.
 */
function instanceOfTestCardFileDto(value) {
    if (!('href' in value) || value['href'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    return true;
}
function TestCardFileDtoFromJSON(json) {
    return TestCardFileDtoFromJSONTyped(json, false);
}
function TestCardFileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'href': json['href'],
        'mimeType': json['mimeType'],
        'sizeInBytes': json['sizeInBytes'] == null ? undefined : json['sizeInBytes'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
    };
}
function TestCardFileDtoToJSON(json) {
    return TestCardFileDtoToJSONTyped(json, false);
}
function TestCardFileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'href': value['href'],
        'mimeType': value['mimeType'],
        'sizeInBytes': value['sizeInBytes'],
        'fileName': value['fileName'],
    };
}
//# sourceMappingURL=TestCardFileDto.js.map